import { defineComponent as _defineComponent } from 'vue'
import { message } from 'ant-design-vue'
import { computed, ref } from 'vue'
import Vue from 'vue'

import MTrimExample from './m-trim-example.vue'

interface formDataType {
  trimmingMethod: string
  trimValue: string
  isCustomTrim: boolean
  topTrim: string
  bottomTrim: string
  leftTrim: string
  rightTrim: string
}

export default /*#__PURE__*/_defineComponent({
  __name: 'm-surplus-trim-setting',
  props: {
    isVisible: { type: Boolean },
    formData: { default: () => ({
      trimmingMethod: 'follow', // 默认选中跟随原片中标准板材的修边值
      trimValue: '', // 修边值
      isCustomTrim: false, // 是否是自定义修边
      topTrim: '', // 上修边
      bottomTrim: '', // 下修边
      leftTrim: '', // 左修边
      rightTrim: '', // 右修边
    }) }
  },
  emits: ['update:isVisible', 'saveDefaultSurplusTrimData'],
  setup(__props: any, { emit: emits }) {

const props = __props as { isVisible: boolean, formData: formDataType }


const formData = computed(() => props.formData)

const isVisible = computed({
  get: () => props.isVisible,
  set: (val: boolean) => emits('update:isVisible', val),
})

const rules = {
  topTrim: [
    {
      required: true,
      message: Vue.prototype.$translateLang('请输入上修边值'),
      trigger: 'blur',
    },
  ],
  bottomTrim: [
    {
      required: true,
      message: Vue.prototype.$translateLang('请输入下修边值'),
      trigger: 'blur',
    },
  ],
  leftTrim: [
    {
      required: true,
      message: Vue.prototype.$translateLang('请输入左修边值'),
      trigger: 'blur',
    },
  ],
  rightTrim: [
    {
      required: true,
      message: Vue.prototype.$translateLang('请输入右修边值'),
      trigger: 'blur',
    },
  ],
}
function handleCancel() {
  isVisible.value = false
}
function handleInputCheck($event: any, prop: string) {
  const value = $event.target?.value
  // 正则表达式：匹配最多五位整数和两位小数
  const validValue = (value.match(/^\d{0,5}(\.\d{0,2})?/)?.[0] || '') as any
  // 更新修边值
  ;(formData.value as any)[prop] = validValue
  // 更新输入框内容
  $event.target.value = validValue
}
/** @description 保存默认修边设置 */
const formRef = ref()
async function handleSaveDefaultTrim() {
  // 跟随标准板修边，不用校验，直接保存

  if (formData.value.trimmingMethod == 'follow') {
    isVisible.value = false
    emits('saveDefaultSurplusTrimData', formData.value)
    return
  }

  // 自定义修边逻辑
  if (formData.value.isCustomTrim) {
    try {
      await (formRef.value as any).validate()
      // 校验通过，关闭弹窗
      isVisible.value = false
      emits('saveDefaultSurplusTrimData', formData.value)
    } catch (err) {
      console.log('校验失败', err)
      message.error(
        Vue.prototype.$translateLang('请检查自定义修边输入是否完整')
      )
    }
    return
  }

  // 非自定义修边逻辑
  if (!formData.value.trimValue) {
    return message.error(Vue.prototype.$translateLang('请输入修边值'))
  }

  isVisible.value = false
  emits('saveDefaultSurplusTrimData', formData.value)
}

return { __sfc: true,props, formData, emits, isVisible, rules, handleCancel, handleInputCheck, formRef, handleSaveDefaultTrim, MTrimExample }
}

})